<template>
  <div>
    <Spinner v-if='isSearching' />

    <div class='notification is-info' v-if='hasEmptySearchResult'>No matching hunt area found.</div>

    <div class='notification is-danger' v-if='searchError'>{{ searchError }}</div>

    <HuntAreaSearchResultList
      v-if='showHuntAreasList'
      :huntAreas='searchResult'
      :selectedHuntAreaId='selectedHuntAreaId'
      @hunt-area-selected='selectHuntArea($event)'/>
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'
import HuntAreaSearchResultList from './HuntAreaSearchResultList'

import {
  RESET_USERS_CACHE
} from '@/modules/users/usersCacheStore.js'

import {
  RESET_HUNT_AREAS_CACHE
} from '@/modules/huntareas/huntAreasCacheStore'

import {
  HUNT_AREAS_SEARCH_STORE_NAMESPACE,
  SEARCH_HUNT_AREAS,
  IS_SEARCHING,
  GET_SEARCH_RESULT,
  GET_SEARCH_ERROR,
  HAS_EMPTY_SEARCH_RESULT,
  INVALIDATE_SEARCH_RESULTS
} from './huntAreasSearchStore'

import {
  SET_HUNT_AREA,
  GET_HUNT_AREA
} from './huntAreaStore'

export default {
  name: 'HuntAreasSearch',
  components: {
    Spinner,
    HuntAreaSearchResultList
  },

  props: {
    query: {
      type: String,
      default: ''
    },

    selectedHuntAreaStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    },

    huntAreasCacheStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
    }
  },

  mounted() {
    if (this.$route.name === 'huntAreasSearch') {
      // Only reset search when a new search has started
      this.resetSelectedHuntArea()

      const invalidateSearchResultsAction = `${HUNT_AREAS_SEARCH_STORE_NAMESPACE}/${INVALIDATE_SEARCH_RESULTS}`
      this.$store.dispatch(invalidateSearchResultsAction)
    }

    this.performSearch()
  },

  methods: {
    performSearch() {
      const query = this.query
      const searchHuntAreasAction = `${HUNT_AREAS_SEARCH_STORE_NAMESPACE}/${SEARCH_HUNT_AREAS}`
      this.$store.dispatch(searchHuntAreasAction, { query })
    },

    selectHuntArea(huntArea) {
      const setHuntAreaAction = `${this.selectedHuntAreaStorePath}/${SET_HUNT_AREA}`
      this.$store.dispatch(setHuntAreaAction, { huntArea })

      const huntAreaStorePath = this.selectedHuntAreaStorePath
      const huntAreaId = huntArea.id
      this.$router.push({ name: 'huntAreaDetails', params: { huntAreaStorePath, huntAreaId }, query: this.$route.query })
    },

    resetSelectedHuntArea() {
      // Reset selected hunt area
      const setHuntAreaAction = `${this.selectedHuntAreaStorePath}/${SET_HUNT_AREA}`
      this.$store.dispatch(setHuntAreaAction, { huntArea: null })

      // Reset users cache
      const resetUsersCacheAction = `${this.usersCacheStorePath}/${RESET_USERS_CACHE}`
      this.$store.dispatch(resetUsersCacheAction)

      // Reset hunt areas cache
      const resetHuntAreasCacheAction = `${this.huntAreasCacheStorePath}/${RESET_HUNT_AREAS_CACHE}`
      this.$store.dispatch(resetHuntAreasCacheAction)
    }
  },

  computed: {
    showHuntAreasList() {
      if (!this.searchResult) {
        return false
      }

      return this.searchResult.length > 0
    },

    isSearching() {
      const isSearching = `${HUNT_AREAS_SEARCH_STORE_NAMESPACE}/${IS_SEARCHING}`
      return this.$store.getters[isSearching]
    },

    searchResult() {
      const getSearchResult = `${HUNT_AREAS_SEARCH_STORE_NAMESPACE}/${GET_SEARCH_RESULT}`
      return this.$store.getters[getSearchResult]
    },

    searchError() {
      const getSearchError = `${HUNT_AREAS_SEARCH_STORE_NAMESPACE}/${GET_SEARCH_ERROR}`
      return this.$store.getters[getSearchError]
    },

    selectedHuntAreaId() {
      const getHuntArea = `${this.selectedHuntAreaStorePath}/${GET_HUNT_AREA}`
      const huntArea = this.$store.getters[getHuntArea]
      if (!huntArea) {
        return null
      }

      return huntArea.id
    },

    hasEmptySearchResult() {
      const hasEmptySearchResult = `${HUNT_AREAS_SEARCH_STORE_NAMESPACE}/${HAS_EMPTY_SEARCH_RESULT}`
      return this.$store.getters[hasEmptySearchResult]
    }
  },

  watch: {
    searchResult() {
      if (!this.searchResult) {
        return
      }

      // Automatically select a hunt area after a new search if result count is 1
      if (this.searchResult.length === 1 && this.$route.name === 'huntAreasSearch') {
        this.selectHuntArea(this.searchResult[0])
      }
    }
  }
}
</script>

<style>

</style>
